import { render, staticRenderFns } from "./VehicleSourceProcedureInformationField.vue?vue&type=template&id=0c2c4020&scoped=true"
import script from "./VehicleSourceProcedureInformationField.vue?vue&type=script&lang=ts"
export * from "./VehicleSourceProcedureInformationField.vue?vue&type=script&lang=ts"
import style0 from "./VehicleSourceProcedureInformationField.vue?vue&type=style&index=0&id=0c2c4020&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2c4020",
  null
  
)

export default component.exports